export default "__VITE_ASSET__C7kdNh$B__"